import { CssBaseline } from '@mui/material'
import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles'
import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { queryClient } from 'helpers/queryClient'
import { getLanguage, languageToLocalization } from 'localization/localization.helper'
import React, { PropsWithChildren, ReactElement } from 'react'
import { I18nProvider } from 'react-aria-components'
import theme from 'styles/theme/theme'
import { AuthProvider } from 'ui/components/AuthContext/AuthContext'
import { ChartSettingsProvider } from 'ui/components/ChartSettingsContext/ChartSettingsContext'
import { PusherProvider } from 'ui/components/PusherContext/PusherContext'

const pusherConfig = {
  clientKey: process.env.REACT_APP_PUSHER_KEY,
  cluster: `eu`,
}

export default function AllProviders({ children }: PropsWithChildren<Record<string, unknown>>): ReactElement {
  const locale = languageToLocalization(getLanguage())

  return (
    <QueryClientProvider client={queryClient}>
      <I18nProvider locale={locale}>
        <StyledEngineProvider injectFirst>
          <ThemeProvider theme={theme}>
            <PusherProvider {...pusherConfig}>
              <ChartSettingsProvider>
                <AuthProvider>
                  <CssBaseline />
                  {children}
                </AuthProvider>
              </ChartSettingsProvider>
            </PusherProvider>
          </ThemeProvider>
        </StyledEngineProvider>
      </I18nProvider>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  )
}
